module.exports = __webpack_public_path__ + "static/media/Products (9).a5a91386.png";